import { ValidationRule } from './validation_rule';

export default abstract class ValidationMapBase {
	[index: string]: ValidationRule[];
}

export abstract class ModelBase {
	[index: string]: any;
}
